"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.existingLogin = void 0;
var React = require("react");
var react_redux_1 = require("react-redux");
var classnames_1 = require("classnames");
var ExistingLoginAction_1 = require("@/pages/search/actions/sfilter/ExistingLoginAction");
var mapStateToProps = function (state) { return (__assign({}, state.existingLogin)); };
var mapDispatchToProps = function (dispatch) { return ({
    onExistingCloseClicked: function () { return dispatch(ExistingLoginAction_1.default.onExistingCloseClicked()); },
    onExistingLoginClicked: function () { return dispatch(ExistingLoginAction_1.default.onExistingLoginClicked()); },
}); };
exports.existingLogin = function (props) {
    var classes = classnames_1.default([
        'l-fullscreen-dim',
        'l-fullscreen-dim--center',
        'c-dialog',
        {
            'c-dialog--active': props.isActive,
            'l-fullscreen-dim--active': props.isActive,
        },
    ]);
    var onBgClicked = function (event) {
        if (event.currentTarget !== event.target)
            return;
        onCloseClicked();
    };
    var onCloseClicked = function () {
        props.onExistingCloseClicked();
    };
    var onLoginClicked = function () {
        props.onExistingLoginClicked();
    };
    return (React.createElement("div", { id: "js-existing-login-dialog", onClick: onBgClicked, className: classes },
        React.createElement("div", { className: "c-dialog__main" },
            React.createElement("a", { id: "js-existing-dialog-close-btn", onClick: onCloseClicked, className: "c-dialog__close" },
                React.createElement("span", { className: "fal fa-times" })),
            React.createElement("div", { className: "c-dialog__title" }, props.t.heading),
            React.createElement("div", { className: "c-dialog__body l-pad-around" },
                React.createElement("div", { className: "c-dialog__caption" }, props.t.caption),
                React.createElement("div", { className: "c-dialog__actions" },
                    React.createElement("a", { id: "js-existing-dialog-login-btn", onClick: onLoginClicked, className: "o-btn c-dialog__action o-btn--primary" },
                        React.createElement("span", null, props.t.login)),
                    React.createElement("a", { id: "js-existing-dialog-cancel-btn", onClick: onCloseClicked, className: "o-btn c-dialog__action" },
                        React.createElement("span", null, props.t.cancel)))))));
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(exports.existingLogin);
